import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SELECT_SERVICE_URL, SIGN_IN_URL } from '../../constants/AppUrlConstants';
import Auth from '../Auth';

const AdminRoutes = () => {
  const location = useLocation();
  const isAuthenticated = !!Auth.isAuthorized();
  const isAdmin = Auth.retrieveUserAccess()?.admin;
  const redirectTo = (!isAdmin) ? SELECT_SERVICE_URL : SIGN_IN_URL;

  return (
    (isAuthenticated && isAdmin) ? <Outlet /> : <Navigate to={redirectTo} state={{ redirectURL: location }} replace />
  );
};

export default AdminRoutes;
